import { ApiError } from "@/api/client";

export type NoGoPipelineConflict = {
  message: string;
  pipelineId?: string;
};

/** Extract 409 HAS_PIPELINE details for Discard-in-Pipeline CTA. */
export function parseNoGoPipelineConflict(err: unknown): NoGoPipelineConflict | null {
  if (!(err instanceof ApiError) || err.status !== 409) return null;
  const body = err.body;
  if (typeof body !== "object" || body === null) {
    return { message: err.message };
  }
  const record = body as Record<string, unknown>;
  return {
    message:
      typeof record.error === "string" ? record.error : err.message,
    pipelineId:
      typeof record.pipelineId === "string" ? record.pipelineId : undefined,
  };
}
